/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { TwoColOneAd } from "./two-col-one-ad";
import { HalfImageSlider } from "./half-screen-slider.js";
import { FullscreenSimpleSlider } from "./fullscreen-simple-slider.js";
import { FullscreenLinearGallerySlider } from "./fullscreen-linear-gallery-slider.js";
import { ThreeCol } from "./three-col";
import { TwoCol } from "../two-col/two-col.js";
import { LShapeOneWidget } from "../l-shape/l-shape-one-widget.js";
import { FullImageSlider } from "./full-screen-slider.js";
import { TwoColCarousel } from "./two-col-carousel.js";
import { TwoColHighlight } from "./two-col-highlight.js";
import { FourColGrid } from "./four-col-grid.js";
import { AdSlotRow } from "./ad-slot-row";
import { CustomWidgetRow } from "./custom-widget-row";
import { OneColStoryList } from "./one-col-story-list.js";
import { SliderCollectionOfCollections } from "./slider-collection-of-collections.js";
import { ThreeColGrid } from "./../collection-templates/three-col-grid/three-col-grid.js";
import { AuthorsListComponent } from "../pages/authors-list";

import ArrowThreeColGrid from "../../../arrow-components/src/components/Rows/ThreeColGrid";
import ArrowFourColGrid from "../../../arrow-components/src/components/Rows/FourColGrid";
import ArrowElevenStories from "../../../arrow-components/src/components/Rows/ElevenStories";
import ArrowOneColStoryList from "../../../arrow-components/src/components/Rows/OneColStoryList";
import ArrowTwoColThreeStories from "../../../arrow-components/src/components/Rows/TwoColThreeStory";
import ArrowThreeColSixStories from "../../../arrow-components/src/components/Rows/ThreeColSixStories";
import ArrowTwoColFourStories from "../../../arrow-components/src/components/Rows/TwoColFourStory";
import ArrowThreeColSevenStory from "../../../arrow-components/src/components/Rows/ThreeColSevenStory";
import ArrowCollectionFilter from "../../../arrow-components/src/components/Rows/CollectionFilter";
import ArrowTagIntroductionCard from "../../../arrow-components/src/components/Rows/TagIntroductionCard";
import ArrowAuthorIntroductionCard from "../../../arrow-components/src/components/Rows/AuthorIntroductionCard";
import ArrowHalfScreenSlider from "../../../arrow-components/src/components/Rows/HalfScreenSlider";
import ArrowFullScreenSlider from "../../../arrow-components/src/components/Rows/FullScreenSlider";
import ArrowFourStorySlider from "../../../arrow-components/src/components/Rows/FourStorySlider";
import { AuthorPageIntroductionCard } from "../../../arrow-components/src/components/Molecules/AuthorPageIntroductionCard";
import { PageIntroduction } from "../molecules/introduction-card";

import { arrowWrapper } from "./arrow/index.js";
import SearchPageLayout from "../pages/search-page/search-layout";
import WithSubsequentLoad from "../hoc-components/with-subsequent-load";
import { MagazineIssuesPage } from "../pages/magazine-issues";

// setting max story limit for arrow components
const wrapperForStoryLimits = Component => {
  const arrowWrapperWithStoryLimits = arrowWrapper(Component);

  arrowWrapperWithStoryLimits.storyLimit = 16;
  return arrowWrapperWithStoryLimits;
};

export default {
  HalfImageSlider,
  TwoColOneAd,
  FullscreenSimpleSlider,
  ThreeCol,
  FullscreenLinearGallerySlider,
  TwoCol,
  TwoColHighlight,
  TwoColCarousel,
  LShapeOneWidget,
  FullImageSlider,
  FourColGrid,
  OneColStoryList,
  SliderCollectionOfCollections,
  ThreeColGrid,
  ArrowCollectionFilter: wrapperForStoryLimits(ArrowCollectionFilter),
  ArrowThreeColGrid: wrapperForStoryLimits(WithSubsequentLoad(ArrowThreeColGrid)),
  ArrowFourColGrid: wrapperForStoryLimits(WithSubsequentLoad(ArrowFourColGrid)),
  ArrowOneColStoryList: wrapperForStoryLimits(WithSubsequentLoad(ArrowOneColStoryList)),
  ArrowThreeColSixStories: wrapperForStoryLimits(ArrowThreeColSixStories),
  ArrowTwoColThreeStories: wrapperForStoryLimits(ArrowTwoColThreeStories),
  ArrowElevenStories: wrapperForStoryLimits(ArrowElevenStories),
  ArrowTwoColFourStories: wrapperForStoryLimits(ArrowTwoColFourStories),
  ArrowHalfScreenSlider: wrapperForStoryLimits(ArrowHalfScreenSlider),
  ArrowFullScreenSlider: wrapperForStoryLimits(ArrowFullScreenSlider),
  ArrowFourStorySlider: wrapperForStoryLimits(ArrowFourStorySlider),
  ArrowThreeColSevenStory: wrapperForStoryLimits(ArrowThreeColSevenStory),
  ArrowTagIntroductionCard: PageIntroduction(ArrowTagIntroductionCard),
  ArrowAuthorIntroductionCard: PageIntroduction(ArrowAuthorIntroductionCard),
  ArrowAuthorPageIntroductionCard: PageIntroduction(AuthorPageIntroductionCard),
  AuthorsListComponent: arrowWrapper(AuthorsListComponent),
  Leaderboard: AdSlotRow,
  SuperLeaderboard: AdSlotRow,
  Billboard: AdSlotRow,
  Custom: AdSlotRow,
  widget: CustomWidgetRow,
  SearchPage: SearchPageLayout,
  MagazineIssuesPage: MagazineIssuesPage,
  defaultTemplate: ThreeCol
};
